import { Badge } from "@/core/components/ui/badge";
import { Calendar, Building2 } from "lucide-react";
import { ExportInsightsFiltersSummaryProps } from "../types";
import { useTranslation } from "react-i18next";
import { formatDate } from "@/core/utils";

export function ExportInsightsFiltersSummary({
  filters,
}: ExportInsightsFiltersSummaryProps) {
  const [translate] = useTranslation(["insights"]);
  return (
    <div className="space-y-4">
      <div className="flex items-center gap-3 p-4 bg-secondary-200 rounded-lg">
        <Calendar className="h-4 w-4 text-primary" />
        <div>
          <p className="font-medium text-sm">
            {translate("export-insights-filters-summary-period-selected")}
          </p>
          <p className="text-sm text-muted-950">
            {formatDate(filters.startDate)} até {formatDate(filters.endDate)}
          </p>
        </div>
      </div>

      {filters.group_id && (
        <div className="flex items-center gap-3 p-4 bg-secondary-200 rounded-lg">
          <Building2 className="h-4 w-4 text-primary" />
          <div>
            <p className="font-medium text-sm">
              {translate("export-insights-filters-summary-spaces")}
            </p>
            <Badge variant="secondary" className="mt-1">
              {String(filters.group_id)}
            </Badge>
          </div>
        </div>
      )}
    </div>
  );
}
